import { bnb } from '@0xtorch/core'
import { bsc } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createBscChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createBscChainCustom({
    client: createClient({
      chain: bsc,
      httpRpcs: bscHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'BscScan',
      baseUrl: 'https://bscscan.com',
      chainId: 56,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateBscParameters = {
  client: Client
  explorer: Explorer
}

export const createBscChainCustom = ({
  client,
  explorer,
}: CreateBscParameters): Chain => ({
  id: 56,
  network: 'bsc',
  name: 'BNB Smart Chain',
  nativeToken: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18,
    currency: bnb,
  },
  wrappedTokenAddresses: new Set([
    '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
  ]),
  explorer,
  client,
  blockTime: 3000,
  coingeckoId: 'binance-smart-chain',
  defillamaId: 'bsc',
})

export const bscHttpRpcs: HttpRpc[] = [
  {
    url: 'https://bsc-dataseed.bnbchain.org/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed1.defibit.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed1.ninicoin.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed2.defibit.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed3.defibit.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed4.defibit.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed2.ninicoin.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed3.ninicoin.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed4.ninicoin.io/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed1.bnbchain.org/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed2.bnbchain.org/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed3.bnbchain.org/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://bsc-dataseed4.bnbchain.org/',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://bsc-dataseed6.dict.life/',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://rpc-bsc.48.club',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://koge-rpc-bsc.48.club',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://endpoints.omniatech.io/v1/bsc/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 3000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://bsc-pokt.nodies.app',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://bsc-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 50_000n,
  },
  {
    url: 'https://go.getblock.io/cc778cdbdf5c4b028ec9456e0e6c0cf3',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://bsc.rpcgator.com/',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://binance.nodereal.io',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://bsc-mainnet.rpcfast.com?api_key=xbhWBI1Wkguk8SNMu1bvvLurPGLXmgwYeC4S6g2H7WdwFigZSmPWVZRxrskEQwIf',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://1rpc.io/bnb',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://bsc.rpc.blxrbdn.com/',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://bsc.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://bnb.api.onfinality.io/public',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://bsc-rpc.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://bsc.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://api.zan.top/node/v1/bsc/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://bsc.drpc.org',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://services.tokenview.io/vipapi/nodeservice/bsc?apikey=qVHq2o6jpaakcw3lRstl',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://rpc.polysplit.cloud/v1/chain/56',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://public.stackup.sh/api/v1/node/bsc-mainnet',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://bsc-mainnet.gateway.tatum.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://bsc.nownodes.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://bnb.rpc.subquery.network/public',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
]

export const bscWebsocketRpcUrls: readonly string[] = [
  'wss://bsc.publicnode.com',
]
